import script from "./BankAccountFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankAccountFilter.vue?vue&type=script&setup=true&lang=ts"

import "./BankAccountFilter.vue?vue&type=style&index=0&id=99eea2d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99eea2d8"]])

export default __exports__